import { lazy } from 'react';
import { ChunkLoadError } from '../types/customError';

const lazyWithFallback: typeof lazy = dynamicImportFn => {
  return lazy(async () => {
    try {
      return await dynamicImportFn();
    } catch (e) {
      if (typeof e === 'string') {
        return Promise.reject(new ChunkLoadError(e));
      }
      if (e instanceof Error) {
        (e as Error).name = 'ChunkLoadError';
      }
      return Promise.reject(e);
    }
  });
};

export { lazyWithFallback };
